import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { parkingProductCategories } from '@/mocks/parkingProducts';

export default function ProductCatalog() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24" data-product-shop>
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            title="两大类产品，一站式选型"
            en="Parking Products"
            subtitle="覆盖路内泊位与停车场的核心硬件终端，按需组合，支持项目集成与批量采购。"
          />
        </Reveal>

        <div className="mt-12 flex flex-col gap-14">
          {parkingProductCategories.map((category) => (
            <div key={category.key}>
              <Reveal>
                <div className="flex items-center gap-3 mb-6">
                  <span className="w-1.5 h-6 rounded-full bg-primary-500"></span>
                  <h3 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
                    {category.name}
                  </h3>
                  <span className="text-xs md:text-sm text-foreground-500">
                    共 {category.products.length} 款
                  </span>
                </div>
              </Reveal>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {category.products.map((p, i) => (
                  <Reveal key={p.name} delay={i * 60}>
                    <div className="group flex flex-col h-full rounded-lg bg-background-100 border border-background-200 overflow-hidden transition-all duration-300 hover:-translate-y-1 hover:border-primary-300">
                      <div className="w-full h-44 overflow-hidden bg-background-50">
                        <img
                          src={p.image}
                          alt={`${p.name} ${category.name}`}
                          title={`华辉数智 ${p.name}`}
                          className="w-full h-full object-contain p-4 transition-transform duration-300 group-hover:scale-105"
                        />
                      </div>
                      <div className="px-4 py-4 border-t border-background-200 flex items-center justify-center flex-1">
                        <h4 className="font-heading font-bold text-sm md:text-base text-foreground-950 text-center leading-snug">
                          {p.name}
                        </h4>
                      </div>
                    </div>
                  </Reveal>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}